import React from 'react'
import { Broadcast } from 'react-broadcast'
import { Query } from 'react-apollo'
import graphqlQuery from 'graphs/queries/User.graphql'

const UserProvider = ({ children, ...rest }) => (
  <Query query={graphqlQuery} {...rest}>
    {({ loading, data: { user } }) => (
      <Broadcast channel="user" value={{ loading, user }}>
        {children}
      </Broadcast>
    )}
  </Query>
)

export default UserProvider



// WEBPACK FOOTER //
// ./src/components/User/Provider.js